module.exports = new Promise(resolve => {
    const remoteUrl = 'https://template.qa.crewscheduler.vistaglobal.com/renderers/remoteEntry.js';
    const name = 'template';

    const script = document.createElement('script');
    script.src = remoteUrl;
    script.async = true;

    script.onload = () => {
      const proxy = {
        get: (request) => window[name].get(request),
        init: (arg) => {
          try {
            return window[name].init(arg);
          } catch (e) {
            console.error('Init failed for ' + name, e);
          }
        }
      };
      resolve(proxy);
    };

    script.onerror = () => {
      console.warn('Remote ' + name + ' is unreachable at ' + remoteUrl);
      resolve({
        get: () => Promise.resolve(() => ({ default: () => null })),
        init: () => {}
      });
    };

    document.head.appendChild(script);
  });